//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default new RTableHeaders(
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'hr_employee_rut',
        format: 'rut',
    },
    {
        text: 'nombre',
        value: 'full_name',
    },
    {
        text: 'correo electrónico',
        value: 'hr_employee_email',
    },
    {
        text: 'código usuario',
        value: 'auth_code',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            }
        },
    },
    {
        text: 'código autorización',
        value: 'bar_auth_code',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            }
        },
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
)
